import * as Sentry from '@sentry/nextjs';
import 'client-only';

/**
 * Observability for Inngest document-processing realtime token mint/fetch
 * failures. Soft-fail paths call this before falling back to durable polling.
 * Never throws.
 */
export function reportDocumentProcessingRealtimeTokenFailure(args: {
  flowId: string;
  error: unknown;
  surface?: 'api_fetch' | 'wait_for_processed' | 'use_realtime' | 'quick_sign';
}): void {
  const { flowId, error, surface = 'api_fetch' } = args;
  const message = error instanceof Error ? error.message : String(error);

  try {
    Sentry.addBreadcrumb({
      category: 'document_processing',
      message: 'document_processing_realtime_token_unavailable',
      level: 'warning',
      data: {
        flowId,
        surface,
        error: message,
      },
    });
    Sentry.captureException(
      error instanceof Error ? error : new Error(message),
      {
        level: 'warning',
        tags: {
          document_processing_realtime: 'soft_fail',
          surface,
        },
        extra: { flowId },
      }
    );
  } catch {
    // Observability must never interrupt upload or builder UX.
  }
}
